<div
  id="standard-modal"
  role="dialog"
  aria-labelledby="standard-modalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header mb-4">
        <h4 class="modal-title" id="standard-modalLabel">
          {{
            isNew
              ? ('contact.noteEdit.addTitle' | translate)
              : ('contact.noteEdit.editTitle' | translate)
          }}
        </h4>

        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-hidden="true"
          (click)="close()"
        ></button>
      </div>

      @if(isEditing) {
      <form [formGroup]="formGroup" class="mb-4">
        <div class="modal-body">
          <textarea
            formControlName="description"
            class="form-control mb-1"
            [placeholder]="'contact.noteEdit.descriptionPlaceholder' | translate"
            maxlength="320"
            rows="5"
          ></textarea>
        </div>

        <div class="row mx-2">
          <div class="col-12 gap-2 d-flex justify-content-end pb-4">
            <button class="btn btn-outline-secondary" (click)="close()">
              {{ 'contact.noteEdit.cancel' | translate }}
            </button>

            <button
              class="btn btn-primary"
              type="submit"
              (click)="save()"
              [disabled]="
                formGroup.invalid || !isEditing || (loadingSpinner$ | async)
              "
            >
              @if ((loadingSpinner$ | async)) {
              <mat-spinner
                [diameter]="15"
                [color]="'accent'"
                mode="indeterminate"
              />
              } @else { {{ 'contact.noteEdit.save' | translate }} }
            </button>
          </div>
        </div>
      </form>
      } @else {
      <div class="modal-body mb-4">
        <div class="d-flex justify-content-end mb-2">
          <button
            class="btn btn-outline-primary btn-sm rounded"
            (click)="toggleEditing()"
            [title]="'contact.noteEdit.editNoteTooltip' | translate"
          >
            <i class="bi bi-pencil"></i>
          </button>
        </div>
        <div class="d-flex align-items-center text-center border rounded">
          <p
            class="fw-bold flex-grow-1 overflow-auto m-2"
            style="max-height: 200px"
          >
            {{ note?.description }}
          </p>
        </div>
      </div>
      }
    </div>
  </div>
</div>
